import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessDesignActivityCount } from './process-design-activity-count';
export { ProcessDesignActivityCount };
import { processDesignActivityCountSchema } from '@schemas/business-objects/process-design-activity-count';
import { ProcessDesignFormGroup } from './process-design-form-group';

export class ProcessDesignActivityCountFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    activityId: SchemaFormControl;
    status: SchemaFormControl;
    tokenCount: SchemaFormControl;
    designUuid: SchemaFormControl;
    processDesignId: SchemaFormControl;
    processDesign: ProcessDesignFormGroup;
  };

  declare value: Partial<ProcessDesignActivityCount>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(
      processDesignActivityCountSchema,
      ProcessDesignActivityCount,
      data,
      options,
    );
  }

  get object(): ProcessDesignActivityCount {
    return new ProcessDesignActivityCount(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'processDesign':
        return new ProcessDesignFormGroup();
      default:
        return undefined;
    }
  }
}

export class ProcessDesignActivityCountFormArray extends PersistedFormArray {
  readonly entityName = 'ProcessDesignActivityCount' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(
      processDesignActivityCountSchema,
      ProcessDesignActivityCount,
      options,
    );
  }

  protected override createItemGroup() {
    return new ProcessDesignActivityCountFormGroup();
  }

  get array(): ProcessDesignActivityCount[] {
    return this.controls.map(
      (group: ProcessDesignActivityCountFormGroup) => group.object,
    );
  }
}

export class ProcessDesignActivityCountPersistedArray extends PersistedArray<ProcessDesignActivityCount> {
  readonly entityName = 'ProcessDesignActivityCount' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessDesignActivityCount, options);
  }
}
